import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "alegra-loading" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h4 class=\"h4 mt-3 alegra-color-dark\"> Procesando su solicitud, por favor espere... </h4><article class=\"alegra-loading__item background-animation\"><article class=\"container-circles\"><div class=\"circle\"></div><div class=\"circle\"></div></article><article class=\"container-circles\"><div class=\"circle\"></div><div class=\"circle\"></div></article></article>", 2)
const _hoisted_4 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
}